import Api from './baseApi';

export default {
  fetchEmployees() {
    return Api.get('/ums/v1/user?asDict=true');
  },
  async fetch() {
    return  await Api.get('/ums/v1/user');
  },
  async fetchEmail(email) {
    return  await Api.get('/ums/v1/user/' + email);
  },
  async create(user) {
    return await Api.put('/ums/v1/user', user);
  },
  async update(user) {
    return await Api.post('/ums/v1/user', user);
  },
  async delete(email) {
    return await Api.delete('/ums/v1/user/' + email);
  },
  async changePassword(data) {
    return await Api.post('/ums/v1/user/change-password', data);
  },
  async forgotPassword(email) {
    return await Api.post('/ums/v1/user/forgot-password', { email: email });
  }
}
